import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import ProductList from '../ProductList'
import Gift from '../../atoms/Gift'
import {
  isFirstStep,
  isSecondStep,
  removeAllGifts,
  retrieveProducts
} from '../../../utils/helpers'
import { updateInCart } from '../../../store/modules/cart/actions'

import './styles.scss'
import classnames from 'classnames'

const GiftList = ({
  chosenGift,
  setChosenGift,
  gifts,
  setGifts,
  isSelectionVisible,
  setIsSelectionVisible,
  actualFreebieProducts,
  giftsList,
  setGiftsList,
  secondStepGiftsAvailable
}) => {
  const { t } = useTranslation()

  const cart = useSelector(({ cart }) => cart)
  const products = useSelector(({ products }) => products)
  const dispatch = useDispatch()

  const [subscriptionInCart, setSubscriptionInCart] = useState(false)

  const _cartContainsFirstStepGift = cart?.items?.some(item => giftsList[0]?.firstStep?.includes(item.sku))
  const _cartContainsSecondStepGift = cart?.items?.some(item => giftsList[1]?.secondStep?.includes(item.sku))

  const _hasSubscription = cart.items.some(item => item.sku.includes('BUNDLE.C'))

  let _isFirstStep = isFirstStep(cart.total_price)
  const _isSecondStep = isSecondStep(cart.total_price, secondStepGiftsAvailable)

  const firstGifts = retrieveProducts(cart, products, document.querySelector('meta[name="gifts"]').content)
  const secondGifts = retrieveProducts(cart, products, document.querySelector('meta[name="gifts-second-step"]').content)
  const secondFreeProductsThreshold = Number(document.querySelector('meta[name="second_step_free_products_threshold"]').content) ?? null
  if (!secondStepGiftsAvailable) _isFirstStep = true

  const cartItemsProducts = products.length && products.reduce((acc, current) => {
    if (cart.items?.map(({ sku }) => sku)?.includes(current.sku)) acc.push(current)
    return acc
  }, [])
  const hasSpecialProduct = cartItemsProducts && cartItemsProducts.some(item => item.upsell_categories?.includes('special'))
  const specialGiftMessage = document.querySelector('meta[name="gift_list_special_fr_message"]')?.content

  useEffect(() => {
    setGifts(firstGifts)
    if (!secondGifts) return setGiftsList([{ firstStep: firstGifts }])
    setGiftsList([{ firstStep: firstGifts }, { secondStep: secondGifts }])
  }, [products, cart, cart?.items?.length])

  useEffect(() => {
    if (cart.items.some(item => item.sku.includes('BUNDLE'))) {
      setIsSelectionVisible(false)

      setSubscriptionInCart(true)
    } else {
      setSubscriptionInCart(false)
    }
  }, [cart])

  useEffect(() => {
    if (_isFirstStep) {
      if (giftsList[0]?.firstStep?.length > 0) {
        if (chosenGift && chosenGift.price === 0) {
          dispatch(updateInCart(chosenGift, 0))
        }

        if (cart?.items?.find(item => gifts.includes(item.sku))) {
          !chosenGift && setChosenGift(cart?.items?.find(item => giftsList[0].firstStep.includes(item.sku)))
        } else {
          chosenGift && setChosenGift([])
        }
      }
    }

    if (_isSecondStep) {
      if (giftsList[1]?.secondStep?.length > 0) {
        if (chosenGift && chosenGift.price === 0) {
          dispatch(updateInCart(chosenGift, 0))
        }

        if (cart?.items?.find(item => gifts.includes(item.sku))) {
          !chosenGift && setChosenGift(cart?.items?.find(item => giftsList[1].secondStep.includes(item.sku)))
        } else {
          chosenGift && setChosenGift([])
        }
      }
    }
  }, [gifts])

  useEffect(() => {
    const cartContainsBundle = cart?.items?.some(item => item.sku.includes('BUNDLE'))

    if (cartContainsBundle && firstGifts?.length) {
      const addWelcomeKit = products.find(({ sku }) => firstGifts.includes(sku))
      setChosenGift(addWelcomeKit)
      setIsSelectionVisible(false)
      removeAllGifts(cart?.items, dispatch, updateInCart).then(r => r)
    }
  }, [firstGifts?.length])

  const getGiftsList = () => {
    if (!secondFreeProductsThreshold) return giftsList[0]?.firstStep

    if (!_cartContainsFirstStepGift && _isSecondStep) return giftsList[0]?.firstStep

    return _isFirstStep
      ? giftsList[0]?.firstStep
      : _isSecondStep
        ? giftsList[1]?.secondStep
        : []
  }

  function renderText () {
    /* global Shopify */
    if (_isSecondStep && hasSpecialProduct && !_hasSubscription && specialGiftMessage && Shopify.locale === 'fr') return specialGiftMessage

    if (_isSecondStep && !_cartContainsSecondStepGift) {
      return t('slideCart:gifts')
    }

    return subscriptionInCart ? t('slideCart:giftSubscription') : t('slideCart:gift')
  }

  const cartContainBundle = cart?.items?.some(({ sku }) => sku.startsWith('JOONECHARGE.BUNDLE'))

  function renderTextCta () {
    const cartContainsWelcomeKit = cart.items.some(({ sku }) => giftsList[0]?.firstStep?.includes(sku))
    const actualGifts = cart.items.filter(item => item.product_type === 'freebie' && item.product_category === 'gift')

    if (actualGifts.length >= 1 && _hasSubscription) return 'giftCtaUpdate'
    if (actualGifts.length > 1) return 'giftCtaUpdateSecondGift'

    if (cartContainBundle && !cartContainsWelcomeKit) return 'selectGift'

    if (!_cartContainsFirstStepGift && _isSecondStep) return 'giftCtaFirstStep'

    if (_hasSubscription && !cartContainsWelcomeKit) return 'giftCta'
    if (_hasSubscription && cartContainsWelcomeKit) return 'giftCtaUpdate'

    if (_isFirstStep && !_cartContainsFirstStepGift) return 'giftCta'
    if (_isFirstStep && _cartContainsFirstStepGift) return 'giftCtaUpdate'
    if (_isSecondStep && _cartContainsSecondStepGift) return 'giftCtaUpdateSecondGift'
    if (_isSecondStep && !_cartContainsSecondStepGift) return 'giftCtaAddSecondGift'

    if (!secondFreeProductsThreshold && _cartContainsFirstStepGift) return 'giftCtaUpdate'
    if (!secondFreeProductsThreshold) return 'giftCta'
  }

  return (
    <div className='free-products-container'>
      <div className='gift-container'>
        {!cartContainBundle &&
          <img src='https://cdn.shopify.com/s/files/1/1956/4693/files/kdo-dino-100px.gif?v=1639661443' />}
        <div className={classnames('gift', { alignment: cartContainBundle })}>

          {cartContainBundle
            ? <p className='welcomekit-offer-message' dangerouslySetInnerHTML={{ __html: t('slideCart:welcomekit-offer-unselected') }} />
            : <div dangerouslySetInnerHTML={{ __html: renderText() }} />}

          <div
            className={classnames('gift-cta', { alignment: cartContainBundle })}
            onClick={() => setIsSelectionVisible(!isSelectionVisible)}
          >
            {t(`slideCart:${renderTextCta()}`)}
          </div>
        </div>
      </div>

      {isSelectionVisible &&
        <ProductList
          actualFreebieProducts={actualFreebieProducts}
          chosenProduct={chosenGift}
          setChosenProduct={setChosenGift}
          products={getGiftsList() || []}
          setProducts={setGifts}
          TypeComponent={Gift}
          type='gift'
          setIsSelectionVisible={setIsSelectionVisible}
          subscriptionInCart={subscriptionInCart}
          secondStepGiftsAvailable={secondStepGiftsAvailable}
        />}
    </div>
  )
}

export default GiftList
